export default "__VITE_ASSET__DPXhzD0t__"